import * as React from 'react';

import {Avatar} from '../avatar/avatar';
import {colors} from '../colors/colors';

import styles from './option-with-icon.module.css';

export type ListOptionWithIcon = {
    value: string;
    label: string;
    icon?: React.ComponentType<any>;
    // Should be a hex color string
    iconColor?: string;
    avatarUrl?: string;
    initials?: string;
    isLoggedInUser?: boolean;
};

type Props = {
    label: string;
    icon?: React.ComponentType<any>;
    // Should be a hex color string
    iconColor?: string;
    avatarUrl?: string;
    initials?: string;
    isLoggedInUser?: boolean;
};

/**
 * Option component for a GraphQL select object that contains
 * an icon and label for each item in the dropdown.
 */
export function OptionWithIcon(props: Props) {
    return (
        <div className={styles.option}>
            <div className={styles.icon}>
                {renderIcon(props.icon, props.avatarUrl, props.initials, props.iconColor)}
            </div>
            <div className={styles.label}>
                {props.label} {props.isLoggedInUser ? '(You)' : ''}
            </div>
        </div>
    );
}

// @ts-expect-error
const renderIcon = (icon, avatarUrl, initials, iconColor) => {
    if (icon) {
        const Icon = icon;

        const color = iconColor ?? colors.orangeDk;

        return <Icon size={20} fill={color} />;
    }

    if (avatarUrl || initials) {
        return <Avatar size={20} type='users' avatarUrl={avatarUrl} initials={initials} />;
    }

    return null;
};
